import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import UiFormControlLabel from 'ui-components/ui-form-control-label/UiFormControlLabel';
import UiCheckbox from 'ui-components/ui-checkbox/UiCheckbox';
import { UiSwitch } from 'ui-components/index';

export default function Checkboxes({
  keyName,
  options,
  onSubFilterChange,
  toggler = 'checkbox',
}) {
  const { t } = useTranslation();
  const { selectedIds, active } = options;

  const filters = {
    influenceRate: [
      { title: t('filter:highest'), id: 'highest' },
      { title: t('filter:high'), id: 'high' },
      { title: t('filter:medium'), id: 'medium' },
      { title: t('filter:low'), id: 'low' },
      { title: t('filter:lowest'), id: 'lowest' },
    ],
  };

  const handleTogglerChange = (e) => {
    const { checked } = e.target;
    onSubFilterChange({ keyName, active: checked });
  };

  let togglerComponent = null;
  if (toggler === 'switch') {
    togglerComponent = (
      <UiSwitch
        name={keyName}
        checked={options?.active}
        onChange={(event) => {
          handleTogglerChange(event);
        }}
      />
    );
  } else if (toggler === 'checkbox') {
    togglerComponent = (
      <UiCheckbox
        name={keyName}
        checked={options?.active}
        onChange={(event) => {
          handleTogglerChange(event);
        }}
      />
    );
  }

  return (
    <div className='checkboxes grid'>
      <UiFormControlLabel
        className='toggler mr-0'
        label={t(options?.label)}
        control={togglerComponent}
      />
      <div className='wrapper flex mr-8'>
        {filters[keyName]?.map(({ id, title }) => {
          return (
            <UiFormControlLabel
              key={id}
              label={title}
              data-testid={`${keyName}-filter-${id}-label`}
              control={
                <UiCheckbox
                  name={id}
                  checked={selectedIds?.includes(id)}
                  onChange={() => onSubFilterChange({ id, keyName })}
                  inputProps={{
                    'data-testid': `${keyName}-filter-${id}-checkbox`,
                  }}
                  disabled={!active}
                />
              }
            />
          );
        })}
      </div>
    </div>
  );
}

Checkboxes.propTypes = {
  keyName: PropTypes.string,
  options: PropTypes.shape({
    selectedIds: PropTypes.array,
    active: PropTypes.bool,
    label: PropTypes.string,
  }),
  onSubFilterChange: PropTypes.func,
  toggler: PropTypes.oneOf(['switch', 'checkbox']),
};
